export default __webpack_public_path__ + "static/media/magnumlogo.8dcd0214.png";